import { Hero } from "@/components/site/Hero";
import { Marquee } from "@/components/site/Marquee";
import { HomeIntro } from "@/components/site/HomeSections";
import { FlavourWheel } from "@/components/site/FlavourWheel";
import { StatsCounter } from "@/components/site/StatsCounter";
import { PhotoStrip } from "@/components/site/PhotoStrip";
import { TeamTeaser } from "@/components/site/TeamTeaser";
import { StoryTeaser, ReviewsTeaser } from "@/components/site/HomeTeasers";
import { NearbyStores } from "@/components/site/NearbyStores";
import { MostPopular } from "@/components/site/MostPopular";
import { LaunchCountdown } from "@/components/site/LaunchCountdown";
import { DoorstepBand } from "@/components/site/DoorstepBand";

export default function HomePage() {
  return (
    <>
      <Hero />
      <Marquee />
      <LaunchCountdown />
      <MostPopular />
      <FlavourWheel />
      <DoorstepBand />
      <HomeIntro />
      <StatsCounter />
      <StoryTeaser />
      <TeamTeaser />
      <PhotoStrip />
      <ReviewsTeaser />
      <NearbyStores />
    </>
  );
}
